module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: _vm.getClasses()
  }, [(_vm.label) ? _c('label', {
    staticClass: "text-info",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": _vm.name,
      "rows": _vm.rows || null,
      "required": _vm.required,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm._f("br2nl")(_vm.value)
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterEvent.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ecd5c41e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputTextarea.vue
// module id = 1049
// module chunks = 34